import { get } from "../api";


export const getSaasMetricData = (id, formattedDate, signal, params={}) => {
  const url = `/api/v2/customers/${id}/saasmetricview/${formattedDate}/`;
  return get(url, params, false, signal, true);
};

export const getSaasPlValues = (id, formattedDate, signal, params={}) => {
  const url = `/api/v2/customers/${id}/saasplvalues/${formattedDate}/`;
  return get(url, params, false, signal, true);
};

export const getSaasMetricCardSummary = (id, formattedDate, type, signal, params={}) => {
  const url = `/api/v2/customers/${id}/saas-metric-card-summary/${type}/${formattedDate}`;
  return get(url, params, false, signal, true);
};